import styled from 'styled-components';

const SurfaceActionBar = styled.div`
    margin: ${props => props.theme.spacing(2, 0, 0, 0)};
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: ${p => p.theme.spacing(1)};
`;

export default SurfaceActionBar;
export { SurfaceActionBar };